"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "useDictateAbortable", {
  enumerable: true,
  get: function get() {
    return _useDictateAbortable.default;
  }
});
Object.defineProperty(exports, "useFocus", {
  enumerable: true,
  get: function get() {
    return _useFocus.default;
  }
});
Object.defineProperty(exports, "useMakeThumbnail", {
  enumerable: true,
  get: function get() {
    return _useMakeThumbnail.default;
  }
});
Object.defineProperty(exports, "useMicrophoneButtonClick", {
  enumerable: true,
  get: function get() {
    return _MicrophoneButton.useMicrophoneButtonClick;
  }
});
Object.defineProperty(exports, "useMicrophoneButtonDisabled", {
  enumerable: true,
  get: function get() {
    return _MicrophoneButton.useMicrophoneButtonDisabled;
  }
});
Object.defineProperty(exports, "useObserveScrollPosition", {
  enumerable: true,
  get: function get() {
    return _useObserveScrollPosition.default;
  }
});
Object.defineProperty(exports, "useObserveTranscriptFocus", {
  enumerable: true,
  get: function get() {
    return _useObserveTranscriptFocus.default;
  }
});
Object.defineProperty(exports, "useRegisterFocusSendBox", {
  enumerable: true,
  get: function get() {
    return _sendBoxFocus.useRegisterFocusSendBox;
  }
});
Object.defineProperty(exports, "useRenderMarkdownAsHTML", {
  enumerable: true,
  get: function get() {
    return _useRenderMarkdownAsHTML.default;
  }
});
Object.defineProperty(exports, "useScrollDown", {
  enumerable: true,
  get: function get() {
    return _useScrollDown.default;
  }
});
Object.defineProperty(exports, "useScrollTo", {
  enumerable: true,
  get: function get() {
    return _useScrollTo.default;
  }
});
Object.defineProperty(exports, "useScrollToEnd", {
  enumerable: true,
  get: function get() {
    return _useScrollToEnd.default;
  }
});
Object.defineProperty(exports, "useScrollUp", {
  enumerable: true,
  get: function get() {
    return _useScrollUp.default;
  }
});
Object.defineProperty(exports, "useSendBoxSpeechInterimsVisible", {
  enumerable: true,
  get: function get() {
    return _BasicSendBox.useSendBoxSpeechInterimsVisible;
  }
});
Object.defineProperty(exports, "useSendFiles", {
  enumerable: true,
  get: function get() {
    return _useSendFiles.default;
  }
});
Object.defineProperty(exports, "useSendMessage", {
  enumerable: true,
  get: function get() {
    return _useSendMessage.default;
  }
});
Object.defineProperty(exports, "useStyleSet", {
  enumerable: true,
  get: function get() {
    return _useStyleSet.default;
  }
});
Object.defineProperty(exports, "useTextBoxSubmit", {
  enumerable: true,
  get: function get() {
    return _TextBox.useTextBoxSubmit;
  }
});
Object.defineProperty(exports, "useTextBoxValue", {
  enumerable: true,
  get: function get() {
    return _TextBox.useTextBoxValue;
  }
});
Object.defineProperty(exports, "useTypingIndicatorVisible", {
  enumerable: true,
  get: function get() {
    return _BasicTypingIndicator.useTypingIndicatorVisible;
  }
});
Object.defineProperty(exports, "useWebSpeechPonyfill", {
  enumerable: true,
  get: function get() {
    return _useWebSpeechPonyfill.default;
  }
});
var _useDictateAbortable = _interopRequireDefault(require("./useDictateAbortable"));
var _useFocus = _interopRequireDefault(require("./useFocus"));
var _useMakeThumbnail = _interopRequireDefault(require("./useMakeThumbnail"));
var _useObserveScrollPosition = _interopRequireDefault(require("./useObserveScrollPosition"));
var _useObserveTranscriptFocus = _interopRequireDefault(require("./useObserveTranscriptFocus"));
var _useRenderMarkdownAsHTML = _interopRequireDefault(require("./useRenderMarkdownAsHTML"));
var _useScrollDown = _interopRequireDefault(require("./useScrollDown"));
var _useScrollTo = _interopRequireDefault(require("./useScrollTo"));
var _useScrollToEnd = _interopRequireDefault(require("./useScrollToEnd"));
var _useScrollUp = _interopRequireDefault(require("./useScrollUp"));
var _useSendFiles = _interopRequireDefault(require("./useSendFiles"));
var _useSendMessage = _interopRequireDefault(require("./useSendMessage"));
var _useStyleSet = _interopRequireDefault(require("./useStyleSet"));
var _useWebSpeechPonyfill = _interopRequireDefault(require("./useWebSpeechPonyfill"));
var _BasicTypingIndicator = require("../BasicTypingIndicator");
var _BasicSendBox = require("../SendBox/BasicSendBox");
var _MicrophoneButton = require("../SendBox/MicrophoneButton");
var _TextBox = require("../SendBox/TextBox");
var _sendBoxFocus = require("./sendBoxFocus");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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